import { Fragment } from 'react';
import { AppVersionAlert } from 'shared/domains/common-ui';
import { FeatureFlagSettings } from 'shared/domains/featureFlag';
export function GlobalProviders(props) {
    const { children } = props;
    return (<Fragment>
      {children}
      <AppVersionAlert />
      <FeatureFlagSettings />
    </Fragment>);
}
